__turbopack_context__.v({
  "container": "CustomBreadcrumb-module-scss-module__XZw-yq__container",
  "containerItem": "CustomBreadcrumb-module-scss-module__XZw-yq__containerItem",
});
